import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CourseDropdownComponentConfigurator } from './course-dropdown-component.configurator';
import { BaseComboboxDropdownComponent } from '@pl/pl-lib/forms';
import { Course } from 'src/app/core/models/course';

@Component({
  selector: 'app-course-searchable-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/combobox-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/combobox-dropdown.component.scss'
  ]
})
export class CourseSearchableDropdownComponent extends BaseComboboxDropdownComponent<Course> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new CourseDropdownComponentConfigurator();
  }
}
